import { render } from "./ModalNotification.vue?vue&type=template&id=2422683c&scoped=true"
import script from "./ModalNotification.vue?vue&type=script&lang=js"
export * from "./ModalNotification.vue?vue&type=script&lang=js"

import "./ModalNotification.vue?vue&type=style&index=0&id=2422683c&scoped=true&lang=css"

import exportComponent from "C:\\wamp64\\www\\montalvo.ti\\front-on\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2422683c"]])

export default __exports__